import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "@redux/app-state";

export const selectVersionMismatch = createSelector([(state: AppState) => state.shared.versionMismatch], isOpen => isOpen);
